import { parseServerTime } from "@/filters/DateAndTime";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { CensusStats } from "@/store/modules/patient/types";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { TIME_ONLY_FORMAT } from "../shared/util";

@Component({})
export default class HeaderTowerReview extends Vue {
  @Getter("stats", patientNamespace)
  stats!: CensusStats;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  get timeStarted() {
    const startTime = parseServerTime(this.stats.start);
    return startTime.format(TIME_ONLY_FORMAT);
  }
}
